import { Button, ButtonProps } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import LoopIcon from '@mui/icons-material/Loop'
import clsx from 'clsx'
import './BaseButton.scss'

// type BaseButtonProps = ButtonProps & { isLoading: boolean }

interface BaseButtonProps extends ButtonProps {
    isLoading?: boolean
}

const BaseButton = withStyles({
    root: {
        height: '28px',
        borderRadius: '50px !important',
        fontSize: '11px',
        minWidth: '75px',
        textTransform: 'unset',
        '&.Mui-disabled': {
            pointerEvents: 'all',
            cursor: 'not-allowed',
            opacity: '0.7',
        },
    },
})(({ isLoading, children, ...rest }: BaseButtonProps) => (
    <Button {...rest}>
        {isLoading && (
            <LoopIcon
                className={clsx(
                    isLoading
                        ? 'refresh-loading icon-visibility'
                        : 'hide-loading'
                )}
            />
        )}
        {children}
    </Button>
))

export default BaseButton
